module.exports = __webpack_public_path__ + "img/picture_ksdgfz04.5edb9eac.png";